module.exports = __webpack_public_path__ + "mainassets/img/table.eb1e101e.svg";